import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';
@Injectable()
export class TebGiderService {
  public period!: number;
  public tasinirKod!: string;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(period: number, tasinirKod:string, isReadOnly:boolean, isBindCheck:boolean){
    this.period = period;
    this.tasinirKod = tasinirKod
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }
  getData(code: string,control:any, period: number, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select(['Kod', 'Ad', 'Donem', 'EkoGiderKod']);
    } 
    else{
     if(this.tasinirKod)  baseEntity=baseEntity+'?ExTasinirKod='+this.tasinirKod
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select(['Kod', 'Ad', 'Donem', 'EkoGiderKod']);
    if (period) filterArr.push(['Donem', '=', period]);
    }
    if (code) filterArr.push(['EkoGiderKod', '=', code]);
    filterArr.push(['EkoGiderKod.Length', '>=', 6]);
    dataSource.filter(filterArr);
    return dataSource;
}

}
